<template>
  <div class="price-list">
    <div class="container">
      <h1>Unsere Preise</h1>



      <div class="pricing-category">
        <h2>IT Support</h2>
        <div class="divider"></div>
        <div class="pricing-table">
          <div class="pricing-item" v-for="(item, index) in itSupportPricing" :key="index">
            <h2>{{ item.title }}</h2>
            <p>{{ item.description }}</p>
            <p class="price">{{ item.price }}</p>
            <a :href="`mailto:contact@jenstrompler.de?subject=Anfrage%20${encodeURIComponent(item.title)}`" class="booking-button">Interesse? Wir beraten Sie!</a>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
export default {
  name: 'AppPreise',
  data() {
    return {
      itSupportPricing: [
            { title: 'IT-Support ', description: 'Professionelle IT-Unterstützung nach Bedarf – ideal für punktuelle Herausforderungen und schnelle Problemlösungen ohne langfristige Vertragsbindung.', price: '€90' },
            { title: 'DevOPS ', description: 'Optimieren Sie Ihre technische Infrastruktur mit unseren DevOPS-Experten, die nahtlose Integration, Automatisierung und Überwachung Ihrer Systeme gewährleisten.', price: '€110' },
            { title: 'Automatisierung', description: 'Steigern Sie Effizienz und Produktivität durch maßgeschneiderte Automatisierungslösungen – mit oder ohne KI-Integration für wiederkehrende Prozesse und Workflows.', price: '€120' },
            { title: 'AI Engineering', description: 'Nutzen Sie das volle Potenzial künstlicher Intelligenz mit unseren spezialisierten AI-Engineering-Dienstleistungen zur Entwicklung intelligenter, lernfähiger Geschäftsprozesse.', price: '€140' },
            { title: 'APIs ', description: 'Nahtlose Systemintegration durch individuell entwickelte APIs, die Ihre Anwendungen zuverlässig miteinander verbinden und Ihre Daten optimal nutzbar machen.', price: '€150' },
            { title: 'Webapps ', description: 'Verwandeln Sie Ihre Vision in interaktive, benutzerfreundliche Webanwendungen mit modernem Design und optimierter Performance für maximale Kundenzufriedenheit.', price: '€180' }
                  ]
                }
              }
            }
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";

.price-list {
  padding: 80px 0;
  background-color: $background-color;
  text-align: center;

  h1 {
    font-size: 2.5rem;
    animation: fadeInDown 1.2s ease;
  }
}

.divider {
  height: 3px;
  width: 70%;
  margin: 20px auto;
  background-color: $accent-color;
  animation: fadeIn 1s ease;
}

.pricing-category {
  margin-bottom: 60px;

  .pricing-table {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-top: 20px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
}

.pricing-item {
  background: linear-gradient(145deg, lighten($background-color, 5%), darken($background-color, 5%));
  border-radius: 15px;
  padding: 30px;
  text-align: center;
  color: $text-color;
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.25);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  animation: fadeInUp 1.2s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.3);
    animation: pulse 1s infinite;
  }

  h2 {
    font-size: 1.8rem;
    margin-bottom: 15px;
  }

  p {
    font-size: 1rem;
    line-height: 1.6;
  }

  .price {
    font-size: 1.6rem;
    font-weight: bold;
    color: $accent-color;
    margin-top: 20px;
  }

  .booking-button {
    display: inline-block;
    margin-top: 20px;
    padding: 10px 20px;
    font-size: 1rem;
    color: #fff;
    background-color: $accent-color;
    border-radius: 5px;
    text-decoration: none;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: darken($accent-color, 10%);
    }
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.03);
  }
}
</style>

